import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";
import intl from "../../i18n/intl";
import { toast } from "react-toastify";

const initialState = {
  data: [],
  record: null,
  requesting: false,
  error: null,
  action: null,
  query: {
    pageNo: 1,
    pageSize: 50,
    sortBy: "asc",
    sortColumn: "name",
    namePattern: "",
  },
};

const customIntl = intl();

const customFieldSlice = createSlice({
  name: "customFields",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    sectionListRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "section-list";
      state.record = null;
    },
    sectionListSuccess: (state, action) => {
      state.data = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    sectionListFail: (state, action) => {
      state.data = [];
      state.requesting = false;
      state.error = action.payload;
    },
    sectionCreateRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "section-create";
    },
    sectionCreateSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "custom_field_section_create_success" })
      );
    },
    sectionCreateFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    sectionDetailsRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "section-details";
    },
    sectionDetailsSuccess: (state, action) => {
      state.record = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    sectionDetailsFail: (state, action) => {
      state.record = null;
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    sectionUpdateDetailRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "section-update";
    },
    sectionUpdateDetailSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "update_performed" }),
            object: customIntl.formatMessage({ id: "custom_field_section" }),
          }
        )
      );
    },
    sectionUpdateDetailFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    sectionUpdateOrderRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "section-update-order";
    },
    sectionUpdateOrderSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({
          id: "custom_field_section_order_update_success",
        })
      );
    },
    sectionUpdateOrderFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    fieldCreateRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "field-create";
    },
    fieldCreateSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "custom_field_create_success" })
      );
    },
    fieldCreateFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    fieldUpdateRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "field-update";
    },
    fieldUpdateSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "custom_field_update_success" })
      );
    },
    fieldUpdateFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    fieldUpdateOrderRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "field-update-order";
    },
    fieldUpdateOrderSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({
          id: "custom_field_order_update_success",
        })
      );
    },
    fieldUpdateOrderFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    deleteSectionRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "section-delete";
    },
    deleteSectionSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "custom_field_section_delete_success" })
      );
    },
    deleteSectionFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    deleteFieldRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "field-delete";
    },
    deleteFieldSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "custom_field_delete_success" })
      );
    },
    deleteFieldFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
  },
});

export const {
  sectionListRequest,
  sectionListSuccess,
  sectionListFail,
  sectionCreateRequest,
  sectionCreateSuccess,
  sectionCreateFail,
  sectionDetailsRequest,
  sectionDetailsSuccess,
  sectionDetailsFail,
  sectionUpdateDetailRequest,
  sectionUpdateDetailSuccess,
  sectionUpdateDetailFail,
  sectionUpdateOrderRequest,
  sectionUpdateOrderSuccess,
  sectionUpdateOrderFail,
  fieldCreateRequest,
  fieldCreateSuccess,
  fieldCreateFail,
  fieldUpdateOrderRequest,
  fieldUpdateOrderSuccess,
  fieldUpdateOrderFail,
  fieldUpdateRequest,
  fieldUpdateSuccess,
  fieldUpdateFail,
  deleteSectionRequest,
  deleteSectionSuccess,
  deleteSectionFail,
  deleteFieldRequest,
  deleteFieldSuccess,
  deleteFieldFail,
} = customFieldSlice.actions;
export default customFieldSlice.reducer;
